const formatToInitialsCapitalized = ({ wordsList, separator = "" }) =>
  wordsList
    .filter(Boolean)
    .map((value) => value.substring(0, 1).toUpperCase())
    .join(separator);

export default formatToInitialsCapitalized;
